//@utilities
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const DateHelper = require('utilities/dateHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { merge } = require('lodash');
const { isEqual } = require('lodash/lang');
//@constants
const actionTypes = require('constants/actionTypes');
const {
    DEFAULT_COUNTRY,
    FIRST_STEP,
    ONE_HOLDER,
    SECOND_STEP,
    THIRD_STEP,
    TWO_HOLDERS,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    WIZARD_THIRD_STEP,
    CUENTA_AJENA_MAYOR_OFFICIAL,
    CUENTA_AJENA_MAYOR_5
} = require('constants/index');
const {
    FINAL_MAX_HOUSING_COST,
    HABITUAL_HOUSING,
    SECOND_HOUSING,
    MAX_NEED_MONEY,
    MIN_NEED_MONEY,
    MIN_VALUE_COST_OF_HOUSING,
    NEW_HOUSE,
    OLD_HOUSE,
    PERCENTAGE_HABITUAL_HOUSING,
    PERCENTAGE_SECOND_HOUSING,

} = require('constants/mortgageRequestPreApproval').constantsCalculateCuota;
const { HOLDER_OPTION_TWO } = require('constants/mortgageRequestPreApproval').mortgageRequestPreApprovalCommons;
const { YES } = require('constants/index');
const communityCodeName = require('constants/communityCodes').constants;
const { names, codes } = require('constants/communityCodes');
const { HOME_USE } = require('constants/mortgageRequestMortgageDataTypes');
//@actions
const { savePersonalData } = require('actions/mortgageRequest/mortgageRequestSimulationLinkClient');
const { requestState } = require('actions/mortgageRequest/mortgageRequestState');

const setVisibleStep = step => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_STEP,
    payload: {
        step
    }
});
const validateStepProcess = step => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_VALIDATE_STEP,
    payload: {
        step
    }
});
const setHolderValue = (holder, showLoading) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_HOLDER,
    payload: {
        holder,
        showLoading
    }
});
const setDayOfBirth = (dayOfBirth, holder) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_HOLDER_DAY_OF_BIRTH,
    payload: {
        dayOfBirth,
        holder
    }
});
const setMonthOfBirth = (monthOfBirth, holder) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_HOLDER_MONTH_OF_BIRTH,
    payload: {
        monthOfBirth,
        holder
    }
});
const setYearOfBirth = (yearOfBirth, holder) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_HOLDER_YEAR_OF_BIRTH,
    payload: {
        yearOfBirth,
        holder
    }
});
const setFieldValue = (typeValue, value) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_INFO_STEP_ONE,
    payload: {
        typeValue,
        value
    }
});
const setMoneyNeedPercentage = (value) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_MONEY_NEED_PERCENTAGE_VALUE,
    payload: {
        value
    }
});
const setMoneyNeedPercentageError = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_MONEY_NEED_PERCENTAGE_ERROR,
});
const setOwner = (owner, holder) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_HOLDER_OWNER,
    payload: {
        owner,
        holder
    }
})
const setWork = (work, holder) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_HOLDER_WORK,
    payload: {
        work,
        holder
    }
});
const setStudies = (studies, holder) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_HOLDER_STUDIES,
    payload: {
        studies,
        holder
    }
});
const setMaritalStatus = (maritalStatus, holder) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_HOLDER_MARITAL_STATUS,
    payload: {
        maritalStatus,
        holder
    }
});
const setDependents = (dependents, holder) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_HOLDER_DEPENDENTS,
    payload: {
        dependents,
        holder
    }
});
const setInfoOtherLoansMortgages = (holder, typeValue, value) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_INFO_OTHER_LOANS_MORTGAGES,
    payload: {
        holder,
        typeValue,
        value
    }
});
const setIncomes = (incomes, holder) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_HOLDER_INCOMES,
    payload: {
        incomes,
        holder
    }
});
const setExpenses = (expenses, holder) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_HOLDER_EXPENSES,
    payload: {
        expenses,
        holder
    }
});
const validateObligatoryFields = (idModal) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_VALIDATE_OBLIGATORY_FIELDS,
    payload: {
        idModal
    }
});
const loadValidateObligatoryFields = (idModal) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_LOAD_VALIDATE_OBLIGATORY_FIELDS,
    payload: {
        idModal
    }
});
const dirtyWhereHousingField = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_WHERE_HOUSING_DIRTY
});
const setValidFirstStep = (currentStep, valid) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_VALID_FIRST_STEP,
    payload: {
        currentStep,
        valid
    }
});
const changeModalActive = (idModal) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_CHANGE_MODAL_ACTIVE,
    payload: {
        idModal
    }
});

const actionPreviousNextButton = (data) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_CHANGE_MODAL_ACTIVE_PREVIOUS_NEXT_BUTTON,
    actionPrevousNextButton: data
})

const preApprovalInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_REQUEST
});
const preApprovalSuccess = data => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SUCCESS,
    payload: {
        data
    }
});
const insuranceRequestSuccess = data => ({
    type: actionTypes.MORTGAGE_REQUEST_INSURANCE_REQUEST_SUCCESS,
    payload: {
        data
    }
});
const insuranceRequestError = error => ({
    type: actionTypes.MORTGAGE_REQUEST_INSURANCE_REQUEST_ERROR,
    error: error
});

const preApprovalLoadAFI = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_AFI_PRELOAD
});
const preApprovalLoadAFIFinish = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_AFI_PRELOAD_FINISH
});
const preApprovalKO = error => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_KO,
    error: error
})

const preApprovalError = error => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_ERROR,
    payload: {
        error
    }
});
const linkingUserInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_LINK_USER_REQUEST
});
const linkingUserSuccess = () => ({
    type: actionTypes.MORTGAGE_REQUEST_LINK_USER_SUCCESS
});
const linkingUserError = error => ({
    type: actionTypes.MORTGAGE_REQUEST_LINK_USER_ERROR,
    payload: {
        error
    }
});
const preApprovalUUID = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_UUID,
});
const productTypeInfAct = (type, catalog) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_PRODUCT_TYPE,
    payload: {
        type,
        catalog
    }
});
const productTypeInf = (type, catalog) => dispatch => {
    dispatch(productTypeInfAct(type, catalog))
};
const koReturnWizard = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_KO_RETURN_WIZARD,
    error: false
});
const preApprovalCO = payload => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_CO,
    payload
})
const toggleCounterOfferView = (showCounterOfferView) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_TOGGLE_CO_VIEW,
    payload: { showCounterOfferView }
});
const acceptPreApprovalCounterOffer = ({ newAmount, newTerm }) => ({
    type: actionTypes.MORTGAGE_REQUEST_ACCEPT_PRE_APPROVAL_CO,
    payload: {
        newAmount,
        newTerm
    }
});
const resetState = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_RESET_STATE
});

const catalogueInformationInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_CATALOGUE_INFORMATION_REQUEST
});

const catalogueInformationSuccess = (catalogID, collectiveCatalogID, subTypeDocumentID) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_CATALOGUE_INFORMATION_SUCCESS,
    catalogID,
    collectiveCatalogID,
    subTypeDocumentID
});

const catalogueInformationError = error => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_CATALOGUE_INFORMATION_ERROR,
    error
});
const restorePreApprovationDataInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_RESTORE_DATA_REQUEST
});
const restorePreApprovationDataSuccess = data => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_RESTORE_DATA_SUCCESS,
    payload: { data }
});
const restorePreApprovationDataError = error => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_RESTORE_DATA_ERROR,
    error
});

const discardTemporalChangesInCurrentModal = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_DISCARD_TEMPORAL_CHANGES_IN_CURRENT_MODAL
});

const clearTemporalChangesInCurrentModal = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_CLEAR_TEMPORAL_CHANGES_IN_CURRENT_MODAL
});
const insuranceRequestRelatedToMortgageHomeSucces = data => ({
    type: actionTypes.MORTGAGE_REQUEST_INSURANCE_PRE_APPROVAL_SUCCESS,
    payload: {
        data
    }
});
const mortgageHomeInsurance = data => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_HOME_INSURANCE_DATA_SUCCESS,
    payload: {
        data
    }
});

const setFieldValid = field => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_STEP_ONE_FIELD_VALID,
    payload: {
        response: {
            field
        }
    }
});

const setMaxHousingCost = (maxHousingCost, increaseHousingCostRange) => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_MAX_HOUSING_COST,
    payload: {
        response: {
            maxHousingCost,
            increaseHousingCostRange
        }
    }
});

const insuranceRequestRelatedToMortgageHome = preApprovalSuccessData => (dispatch, getState) => {
    const immMortgageRequestPreApproval = getState().mortgageRequestPreApproval;
    const simulationToken = immMortgageRequestPreApproval.get('preApprovalToken');
    const requestData = {
        query: {
            tokenSimulacion: simulationToken
        }
    };
    return APIGet({
        dispatch,
        endpoint: 'insuranceRequestRelatedToMortgageHome',
        params: requestData
    }).then(response => {
        dispatch(insuranceRequestRelatedToMortgageHomeSucces(response.data));
    }).catch(response => {
        if (response.error) {
            dispatch(preApprovalError());
        } else {
            throw response;
        }
    }).finally(() => {
        if (preApprovalSuccessData) {
            dispatch(preApprovalSuccess(preApprovalSuccessData));
        }
    });
}

const preApproval = (isPartialUpdate = false) => (dispatch, getState) => {
    const getParticipants = (currentState, participantsArray) => {
        const numberOfHolders = currentState.get('selectedHolder') === '0' ? ONE_HOLDER : TWO_HOLDERS;
        let participants = participantsArray.filter(participant => participant !== false);
        if (numberOfHolders === ONE_HOLDER && participants.length > 0) {
            participants = [participants[0]];
        }

        return participants;
    };
    const getCommunityId = communityCode => {
        const communityCodeNumber = Number(communityCode);
        let communityId = `${communityCode}`;
        if (communityCodeNumber < 10) {
            communityId = `0${communityCodeNumber}`;
        }
        return communityId;
    };
    const currentState = getState().mortgageRequestPreApproval;
    const fixedTerm = getState().mortgageRequestConditions.getIn(['conditions', 'fixedTerm']);
    const communityId = getCommunityId(currentState.get('whereHousing'));
    const communityName = communityCodeName[communityId];
    const holders = currentState.get('holders').toJS();
    const isNewProperty = currentState.get('typeHousing') === NEW_HOUSE;
    const mortgageCost = currentState.get('moneyNeed');
    const mortgageInsuranceHome = currentState.get('insuranceHomeEnabled');
    const productType = currentState.get('productType');
    const propertyCost = currentState.get('costOfhousing');
    const propertyType = currentState.get('useHousing') === HABITUAL_HOUSING ? HOME_USE.PRIMERA_VIVIENDA : HOME_USE.SEGUNDA_VIVIENDA;
    const term = currentState.get('timeMoneyReturn');
    const token = currentState.get('preApprovalToken');
    const participantsArray = holders.map((holder, index) => {
        let birthDate = '';
        if (holder.yearOfBirth) {
            birthDate = `${holder.yearOfBirth}-${DateHelper.getTwoDigitsMonth(holder.monthOfBirth)}-${DateHelper.getTwoDigitsDay(holder.dayOfBirth)}`;
        }
        const cancelMortgageIndicatorFlag = holder.goingCancelMortgage === null ? null : holder.goingCancelMortgage === YES;
        const civilStatus = holder.maritalStatus;
        const holderCurrentProperty = holder.owner.value;
        const income = Number(holder.incomes);
        const laborSituationPreapproval = holder.work.value === CUENTA_AJENA_MAYOR_OFFICIAL ? CUENTA_AJENA_MAYOR_5 : holder.work.value ;
        const nationality = DEFAULT_COUNTRY;
        const order = index + 1;
        const otherLoanFlag = holder.personalLoans === null ? null : holder.personalLoans === YES;
        const otherLoans = Number(holder.monthlyFeesLoans);
        const otherMortgageParticipant = Number(holder.monthlyFeesMortgage);
        const participant = {};
        const pendingAmmountOthers = Number(holder.pendingAmountLoans);
        const pendingMortgageAmmount = Number(holder.pendingAmountMortgage);
        const peopleInCharge = holder.dependents !== '' ? Number(holder.dependents) : '';
        const rental = Number(holder.expenses);
        const studiesLevel = holder.studies.value;
        merge(
            participant,
            {
                birthDate,
                cancelMortgageIndicatorFlag,
                civilStatus: civilStatus ? civilStatus : undefined,
                holderCurrentProperty,
                income,
                laborSituationPreapproval,
                nationality,
                order,
                otherLoanFlag,
                otherLoans,
                otherMortgageParticipant,
                pendingAmmountOthers,
                pendingMortgageAmmount,
                peopleInCharge,
                rental,
                studiesLevel
            }
        );

        return participant;
    });
    const preApprovalData = {
        'community': communityName,
        'expedientToken': token,
        'includesHomeInsurance': mortgageInsuranceHome,
        'mortgageCost': mortgageCost,
        'newProperty': isNewProperty,
        'partialUpdate': isPartialUpdate,
        'productType': productType,
        'propertyCost': propertyCost,
        'propertyType': propertyType,
        'term': term,
        'fixedTerm': fixedTerm
    };
    const participants = getParticipants(currentState, participantsArray);
    if (participants.length > 0) {
        merge(preApprovalData, {
            'participants': participants
        });
    }
    const requestData = {
        query: preApprovalData
    };
    if (!isPartialUpdate) {
        dispatch(preApprovalInProgress());
    }

    return APIPost({
        dispatch,
        endpoint: 'mortgageRequestPreApproval',
        params: requestData
    })
        .then(response => {
            if (response.data['preApprovalResponse'] === 'OK') {
                dispatch(insuranceRequestRelatedToMortgageHome(response.data));
                dispatch(toggleCounterOfferView(false));
            } else if (response.data['preApprovalResponse'] === 'KO') {
                dispatch(preApprovalKO(true));
                dispatch(toggleCounterOfferView(false));
            } else if (response.data['preApprovalResponse'] === 'CO') {
                dispatch(preApprovalCO(response.data));
                dispatch(toggleCounterOfferView(true));
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(preApprovalError());
            } else {
                throw response;
            }
        });
}
const linkMortgageWithUser = (history) => (dispatch, getState) => {
    const { mortgageRequestPreApproval, globalPosition } = getState();
    const simulationToken = mortgageRequestPreApproval.get('preApprovalToken');
    const isNoClient = globalPosition.get('isClientWithoutAccounts');
    const requestData = {
        query: {
            "clienteOpenBank": !isNoClient,
            "tokenSimulacion": simulationToken
        }
    };
    dispatch(linkingUserInProgress());
    return APIPost({
        dispatch,
        endpoint: 'mortgageRequestSimulationLinkClient',
        params: requestData
    }).then(() => {
        dispatch(linkingUserSuccess());
        dispatch(requestState('/myprofile/mortgage/manager', history));
    }).catch(response => {
        if (!!response.error) {
            dispatch(linkingUserError());
            history.push('/myprofile/mortgage-error');
        } else {
            throw response;
        }
    });
}
const linkMortgage = (history) => dispatch => {
    return dispatch(linkMortgageWithUser(history));
}
const savePartialProcess = () => dispatch => {
    dispatch(preApproval(true));
}
const changeModalActiveSavingProcess = modalId => (dispatch, getState) => {
    const currentState = getState().mortgageRequestPreApproval;
    const activeModal = currentState.get('isModalActive');
    const isChangingModal = modalId !== '' && activeModal !== '';
    const isEditingModal = modalId === '' && activeModal !== '';

    dispatch(changeModalActive(modalId));
    if (isChangingModal || isEditingModal) {
        dispatch(savePartialProcess());
    }
}
const validateStep = (currentStep, history) => (dispatch, getState) => {
    const { mortgageRequestPreApproval, mortgageRequestState, globalPosition } = getState();
    const currentSimulationToken = mortgageRequestPreApproval.get('preApprovalToken');
    const expedientToken = mortgageRequestState.get('token');
    const isPersonalDataSaved = expedientToken === currentSimulationToken;
    const isRncClient = globalPosition.get('isClientWithoutAccounts');
    const isSecondStepValid = mortgageRequestPreApproval.getIn(['steps', SECOND_STEP, 'valid']);
    const isFirstStepValid = getState().mortgageRequestPreApproval.getIn(['steps', FIRST_STEP, 'valid']);

    if (currentStep === WIZARD_SECOND_STEP && isSecondStepValid && !isPersonalDataSaved) {
        dispatch(savePersonalData(currentSimulationToken, !isRncClient, history));
    }
    if (currentStep === WIZARD_THIRD_STEP) {
        dispatch(validateStepProcess(currentStep));
        const isThirdStepValid = getState().mortgageRequestPreApproval.getIn(['steps', THIRD_STEP, 'valid']);
        if (isThirdStepValid) {
            dispatch(preApproval());
            return true;
        }
    }
    if (currentStep === WIZARD_FIRST_STEP && isFirstStepValid) {
        dispatch(setVisibleStep(currentStep + 1));
        return true;
    }
    dispatch(validateStepProcess(currentStep));
    return true;
}

const getInsurancesDataAfi = () => dispatch => {
    return APIGet({
        dispatch,
        endpoint: 'insuranceRequestRelatedConfig',
    }).then(response => {
        dispatch(insuranceRequestSuccess(response));
    }).catch(response => {
        if (response.error) {
            dispatch(insuranceRequestError(response.error));
        } else {
            throw response;
        }
    });
}

const getCatalogInformation = () => (dispatch, getState) => {
    dispatch(catalogueInformationInProgress());
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('mortgageRequestCatalogInformation'),
    ).then(response => {
        dispatch(catalogueInformationSuccess(response.data.catalogue, response.data.collectiveCatalogue, response.data.subTypeDocument));
    }).catch(response => {
        if (!!response.error) {
            dispatch(catalogueInformationError(response));
        } else {
            throw response;
        }
    });
}
const restoreProcess = () => (dispatch, getState) => {
    const { mortgageRequestState, mortgageRequestPreApproval, profile } = getState();
    const expedientState = mortgageRequestState.get('estado');
    const processHasBeenRestored = mortgageRequestPreApproval.get('processHasBeenRestored');
    const defaultBirthDate = profile.get('fechaNacimiento');

    if (!processHasBeenRestored) {
        dispatch(restorePreApprovationDataInProgress());
        return APIGet({
            dispatch,
            endpoint: 'mortgageRequestPreApproval'
        })
            .then(response => {
                const restoredBirthDate = response.data.participants[0].birthDate;
                response.data.expedientState = expedientState;
                response.data.participants[0].birthDate = restoredBirthDate ? restoredBirthDate : defaultBirthDate;
                dispatch(restorePreApprovationDataSuccess(response.data));
                dispatch(insuranceRequestRelatedToMortgageHome());
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(restorePreApprovationDataError(response.error));
                } else {
                    throw response;
                }
            });
    }
}

const setHolder = (holder, history) => (dispatch, getState) => {
    const shouldSave = holder === HOLDER_OPTION_TWO;
    dispatch(setHolderValue(holder, !shouldSave));
    if (shouldSave) {
        const { mortgageRequestPreApproval, globalPosition } = getState();
        const currentSimulationToken = mortgageRequestPreApproval.get('preApprovalToken');
        const isRncClient = globalPosition.get('isClientWithoutAccounts');
        dispatch(savePersonalData(currentSimulationToken, !isRncClient, history));
    }
}

const moneyNeedPercentageCalc = (value, percentage) => {
    const percentageCalc = Math.floor((value / 100) * percentage);
    return percentageCalc;
}

const setMoneyNeedPercentageValue = (value, percentageVal) => dispatch => {
    if (!!value) {
        let percentageCalc = moneyNeedPercentageCalc(value, percentageVal);
        if (percentageCalc > MIN_NEED_MONEY) {
            dispatch(setMoneyNeedPercentage(percentageCalc));
        } else {
            dispatch(setMoneyNeedPercentageError());
        }
    }
}

const setNeedMoneyByUser = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PRE_APPROVAL_SET_NEED_MONEY_BY_USER
});

const setInfoStepOne = (type, value, percentageValueValid) => (dispatch, getState) => {
    dispatch(setFieldValue(type, value));
    dispatch(setFieldValid(type));
    const immMortgageRequestPreApproval = getState().mortgageRequestPreApproval;
    const currentStep = immMortgageRequestPreApproval.get('visibleStep');
    const costOfhousingIsValid = immMortgageRequestPreApproval.get('costOfhousingIsValid');
    const costOfhousing = immMortgageRequestPreApproval.get('costOfhousing');
    const moneyNeedVal = immMortgageRequestPreApproval.get('moneyNeed');
    const needMoneyByUser = immMortgageRequestPreApproval.get('needMoneyByUser');

    if (type === 'costOfhousing') {
        // We have to dispatch a validation for moneyNeed field in order to check the percentage restriction
        if (costOfhousingIsValid && value >= MIN_VALUE_COST_OF_HOUSING && value <= FINAL_MAX_HOUSING_COST) {
            dispatch(setMoneyNeedPercentageValue(value, percentageValueValid));

            const percentageCalc = moneyNeedPercentageCalc(value, percentageValueValid);
            if (moneyNeedVal > MAX_NEED_MONEY || percentageCalc > MAX_NEED_MONEY && !needMoneyByUser) {
                dispatch(setFieldValue('moneyNeed', MAX_NEED_MONEY));
            } else if ((percentageCalc > MIN_NEED_MONEY && percentageCalc <= MAX_NEED_MONEY && costOfhousingIsValid) &&
                (!moneyNeedVal || moneyNeedVal >= percentageCalc) || !needMoneyByUser) {
                dispatch(setFieldValue('moneyNeed', percentageCalc));
            }
            dispatch(setFieldValid('moneyNeed'));
        }
    }

    if (type === 'useHousing') {
        const useHousingPercentage = isEqual(value, HABITUAL_HOUSING) ? PERCENTAGE_HABITUAL_HOUSING : PERCENTAGE_SECOND_HOUSING;
        dispatch(setMoneyNeedPercentageValue(costOfhousing, useHousingPercentage));
        const moneyNeedPercentage = moneyNeedPercentageCalc(costOfhousing, useHousingPercentage);
        if ((moneyNeedPercentage < MIN_NEED_MONEY) && costOfhousing) {
            dispatch(setFieldValue('moneyNeed', MIN_NEED_MONEY));
        } else if ((moneyNeedVal > moneyNeedPercentage) && costOfhousing) {
            dispatch(setFieldValue('moneyNeed', moneyNeedPercentage));
        }
        dispatch(setFieldValid('moneyNeed'));
    }
    dispatch(validateStepProcess(currentStep));
}

const setInfoFromPublicUrl = (queryParams) => (dispatch, getState) => {
    const immMortgageRequestPreApproval = getState().mortgageRequestPreApproval;
    const isPrimaryResidence = queryParams.get('isPrimaryResidence');
    const typeHousing = queryParams.get('housingType');
    const housingLocation = queryParams.get('housingLocation');
    const costOfhousing = queryParams.get('housingPriceBeforeTaxes');
    const moneyNeed = queryParams.get('loanAmountNeeded');
    const repaymentTime = queryParams.get('repaymentTime');
    const percentageValid = isEqual(immMortgageRequestPreApproval.get('useHousing'),HABITUAL_HOUSING)
    ? PERCENTAGE_HABITUAL_HOUSING
    : PERCENTAGE_SECOND_HOUSING;

    const adapter = {
        useHousing: isPrimaryResidence === 'true' ? HABITUAL_HOUSING : SECOND_HOUSING,
        typeHousing: typeHousing === 'first' ? NEW_HOUSE : OLD_HOUSE,
        //we always need to find two digits for the community code
        whereHousing: housingLocation?.length === 1 ? `0${housingLocation}` : housingLocation,
        costOfhousing: Number(costOfhousing),
        moneyNeed: Number(moneyNeed),
        timeMoneyReturn: Number(repaymentTime),
    }

    const keys = Object.keys(adapter);
    keys.forEach((key) => {
        const value = adapter[key];
            dispatch(setInfoStepOne(key, value, percentageValid));
    });
}

module.exports = {
    setVisibleStep,
    validateStep,
    setHolder,
    setDayOfBirth,
    setMonthOfBirth,
    setYearOfBirth,
    setInfoStepOne,
    setOwner,
    setWork,
    setStudies,
    setMaritalStatus,
    setDependents,
    setInfoOtherLoansMortgages,
    setIncomes,
    setExpenses,
    validateObligatoryFields,
    loadValidateObligatoryFields,
    dirtyWhereHousingField,
    setValidFirstStep,
    changeModalActive,
    changeModalActiveSavingProcess,
    linkMortgage,
    preApprovalLoadAFI,
    preApprovalLoadAFIFinish,
    preApprovalUUID,
    mortgageHomeInsurance,
    productTypeInf,
    koReturnWizard,
    toggleCounterOfferView,
    acceptPreApprovalCounterOffer,
    resetState,
    actionPreviousNextButton,
    getCatalogInformation,
    preApproval,
    savePartialProcess,
    restoreProcess,
    discardTemporalChangesInCurrentModal,
    clearTemporalChangesInCurrentModal,
    getInsurancesDataAfi,
    setMoneyNeedPercentageValue,
    setMaxHousingCost,
    setNeedMoneyByUser,
    setInfoFromPublicUrl,
};
